export default "__VITE_ASSET__37edda51__"